import { CANCELLATION_CUTOFF_MESSAGE, GO_BACK_WINDOW_MESSAGE, withinCancellationCutoff, withinGoBackWindow } from "@shyne/shared";

export function canRescheduleOrCancel(appointmentDate: string, appointmentTime?: string): { can: boolean; reason?: string } {
  return withinCancellationCutoff({ date: appointmentDate, time: appointmentTime }) ? { can: false, reason: CANCELLATION_CUTOFF_MESSAGE } : { can: true };
}

export function canGoback(doneAtTimestamp: string | undefined, now: Date = new Date()): { can: boolean; reason?: string } {
  if (!doneAtTimestamp) return { can: false, reason: "Appointment must be marked as done first" };
  return withinGoBackWindow(doneAtTimestamp, now) ? { can: true } : { can: false, reason: GO_BACK_WINDOW_MESSAGE };
}
